import styled from '@emotion/styled'
import { Alert as AntdAlert } from 'antd'

export const Alert = styled(AntdAlert)`
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border: none;
  width: 100%;
  border-radius: 4px;
  margin-bottom: 25px;
`
